export enum Language {
    IT = 'it',
    EN = 'en'
}